// Services
import { toastOptions } from "./service/SnackbarService";
import { containerStyle } from "./service/SnackbarService";
// Third Party
import { Toaster } from "react-hot-toast";
import Router from "./routes/Router";
// Store
import { AuthContextProvider } from "./store/auth-context";

import AppConstants from "./configs/AppConstants";

import { GoogleOAuthProvider } from "@react-oauth/google";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { HistoryProvider } from "./store/HistoryProvider";

function App() {
  return (
    <div className="App">
      <GoogleOAuthProvider clientId={AppConstants.CLIENT_ID} disableOneTap>
        <AuthContextProvider>
          <Toaster
            key="toaster"
            {...{ toastOptions }}
            {...{ containerStyle }}
          />
          <HistoryProvider>
            <Router />
          </HistoryProvider>
        </AuthContextProvider>
      </GoogleOAuthProvider>
    </div>
  );
}

export default App;
